import React from "react";
import { Link } from "react-router-dom";

import Section from "../components/primatives/Section";
import TagButton from "../components/primatives/TagButton";
import SectionHeader from "../components/primatives/SectionHeader";
import ActionButton from "../components/primatives/ActionButton";
import { FiTag, FiLayers, FiPlusSquare } from "react-icons/fi";

function Tags() {
  return (
    <div>
      <Section>
        <SectionHeader><FiLayers /> What are tags?</SectionHeader>
        <div className="text-sm">
          Tags let you organize your key-value pairs by storing them in a shared
          group.
          <br /><br />
          <i>This feature is not available yet..</i>
        </div>
      </Section>

      {/* add new key-val pair link */}
      <Link to="/tags">
        <ActionButton><FiPlusSquare style={{color:'white'}} /> Add new tag (coming soon).</ActionButton>
      </Link>
      <br /><br />

      <Section>
        <SectionHeader>
          <FiTag /> Default
        </SectionHeader>
        <div className="text-sm mb-2">
          This tag stores unassigned key-value pairs.
        </div>
        <Link to="/">
            <TagButton>view tags</TagButton>
        </Link>
        <Link to="/tags">
            <TagButton>delete</TagButton>
        </Link>
      </Section>
    </div>
  );
}

export default Tags;
